export const RecordEmailFragment = gql`
  fragment RecordEmailFragment on RecordEmail {
    id
    sentEmail {
      ...SentEmailFragment
    }
  }
`
